import { InitialState } from "../reducers"
import { ApiSupportSelector } from "../../helpers/apiSupport"

export const Selector = {
    get: (state): InitialState => {
        return state.proposal
    },

    getId: (state) => {
        return Selector.get(state).id
    },

    getStructured: (state) => {
        return {
            id: Selector.getId(state),
            attributes: Selector.get(state)
        }
    },

    getPublicLink: (state) => {
        return Selector.get(state).publicLink
    },

    getPrintUrl: (state) => {
        return Selector.get(state).printUrl
    },

    isFetching : (state) => {
        return Selector.get(state).isFetching
    },

    getApiStatus: (state) => {
        return ApiSupportSelector(Selector.get(state))
    }
}


// WEBPACK FOOTER //
// ./src/state/proposal/selectors/selectors.ts